const $ = require('jquery');
const _ = require('lodash');

module.exports = function ($window) {
    return {
        restrict: 'A',
        scope: false,
        link(scope, element) {
            let lastScroll = 0;
            const $$window = $($window);

            function addClasses() {
                const scrollPosition = $(window).scrollTop();

                // if scroll position is 0 then add class 'scroll-position-default'
                if (scrollPosition === 0) {
                    element.addClass('scroll-position-max-top');
                } else {
                    element.removeClass('scroll-position-max-top');
                }

                if (scrollPosition > lastScroll && scrollPosition > 90) {
                    // if scroll down then add class 'last-scroll-down'
                    element.addClass('last-scroll-down').removeClass('last-scroll-up');
                } else {
                    // else if scroll up then add class 'last-scroll-up'
                    element.addClass('last-scroll-up').removeClass('last-scroll-down');
                }
                lastScroll = scrollPosition;
            }

            (function init() {
                // add event listener to the body container
                 $$window.scroll(_.throttle(addClasses, 100));
            })();

            function unbindEventListener() {
                // remove event listener
                 $$window.unbind('scroll');
            }

            scope.$on('$destroy', unbindEventListener);
        }
    };
};



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/globalheader/global-scroller.js
 **/